import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const names = ['Juan M.', 'María P.', 'Carlos R.', 'Ana G.', 'David L.', 'Laura S.', 'Pedro C.', 'Elena M.'];
const cities = ['Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza', 'Málaga', 'Murcia', 'Bilbao'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Stay for 4 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Recurring interval (every 20 seconds)
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-238">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-center gap-4 max-w-sm" data-id="element-239">
          <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-240">
            <CheckCircle className="text-green-600" size={24} data-id="element-241" />
          </div>
          <div data-id="element-242">
            <p className="text-sm text-gray-800 font-medium" data-id="element-243">
              <span className="font-bold" data-id="element-244">{data.name}</span> de {data.city}{' '}
              acaba de comprar la{' '}
              <span className="font-bold text-blue-600" data-id="element-245">
                Edición Profesional
              </span>
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-246">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}